export default {
  'InfoBox.Wrapper': ({ isytd }, _, internalStateSetter) => {
    internalStateSetter({ isytd: !isytd })
  }
}